import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

export const Tooltip = ({ content, children, position = 'top', forceOpen = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const triggerRef = useRef(null);

  const updatePosition = () => {
    if (!triggerRef.current) return;
    
    const rect = triggerRef.current.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;
    
    let x = rect.left + scrollX + rect.width / 2;
    let y;
    
    if (position === 'bottom') {
      y = rect.top + scrollY + rect.height + 10;
    } else { // 'top' or default
      y = rect.top + scrollY - 35; // מעל האייקון עם מספיק מרווח
    }
    
    setTooltipPosition({ x, y });
  };

  const handleMouseEnter = () => {
    setIsVisible(true);
    updatePosition();
  };

  const handleMouseLeave = () => {
    if (!forceOpen) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (forceOpen) {
      setIsVisible(true);
      setTimeout(() => updatePosition(), 0);
    } else if (!forceOpen) {
      setIsVisible(false);
    }
  }, [forceOpen]);

  useEffect(() => {
    if (isVisible) {
      const handleScroll = () => updatePosition();
      const handleResize = () => updatePosition();
      
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [isVisible]);

     const tooltipContent = isVisible ? (
     <div
       className="fixed px-3 py-2 text-xs text-white bg-gray-900 rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-150 max-w-xs text-center"
       style={{
         left: tooltipPosition.x,
         top: tooltipPosition.y,
         zIndex: 999999,
         pointerEvents: 'none',
       }}
     >
      {content}
      <div
        className="absolute w-2 h-2 bg-gray-900"
        style={{
          left: '50%',
          [position === 'top' ? 'bottom' : 'top']: '-4px',
          transform: 'translateX(-50%) rotate(45deg)',
        }}
      />
    </div>
  ) : null;

  return (
    <>
      <div
        ref={triggerRef}
        className="relative inline-block"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {tooltipContent && createPortal(tooltipContent, document.body)}
    </>
  );
}; 